export default "__VITE_ASSET__d7670ffc__"